import React from 'react';
import { injectIntl } from 'react-intl';

const CookieLink = ({ intl }) => {
  let href = '';
  switch (intl.locale) {
    case 'en':
      href = 'https://portal.jaimy.be/fr_BE/legal';
      break;
    case 'fr':
      href = 'https://portal.jaimy.be/fr_BE/legal';
      break;
    case 'nl':
      href = 'https://portal.jaimy.be/nl_BE/legal';
      break;
    default:
      href = 'https://portal.jaimy.be/fr_BE/legal';
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {intl.messages['footer.contact.cookie-policy.link']}
    </a>
  );
};
export default injectIntl(CookieLink);
